import { useTranslation } from 'next-i18next';
import { useRef } from 'react';
import { useSelector } from 'react-redux';
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { selectIsAuthenticated } from '@store/auth/auth.slice';
import tw from 'twin.macro';
import Link from '@components/elements/Link';
import ROUTE_URLS from '@constants/routeUrls';
import useOnClickOutside from '@hooks/useOnClickOutside';
import useSwitch from '@hooks/useSwitch';
import { pushClickMenuGTMEvent } from '@utils/gtm';
import IconPersonOutline from '@assets/icons/IconPersonOutline';

import AuthNavItems from './AuthNavItems';

const AuthNav = () => {
  const { t } = useTranslation();

  const ref = useRef<HTMLDivElement>(null);

  const isAuthenticated = useSelector(selectIsAuthenticated);

  const [isOpenMenu, openMenu, closeMenu] = useSwitch(false);
  useOnClickOutside(ref, closeMenu);

  if (isAuthenticated) {
    return (
      <div tw="relative mx-2" ref={ref} data-cy="AuthNav_div">
        <div
          tw="cursor-pointer flex items-center text-sm"
          onClick={isOpenMenu ? closeMenu : openMenu}
          data-cy="my-account-dropdown"
        >
          <IconPersonOutline tw="w-5 h-5" />
          <span tw="ml-3 mr-2">{t('$*components.header.myAccount')}</span>
          <FontAwesomeIcon
            icon={isOpenMenu ? faChevronUp : faChevronDown}
            tw="text-xs"
          />
        </div>
        {isOpenMenu && (
          <div tw="absolute bg-white shadow-md whitespace-nowrap right-0 top-10 text-sm rounded-lg">
            <AuthNavItems onLinkClick={closeMenu} />
          </div>
        )}
      </div>
    );
  }

  return (
    <div tw="flex items-center">
      <Link
        href={ROUTE_URLS.AUTH_LOGIN}
        styles={tw`mx-3`}
        data-cy="nav__login"
        onClick={() => {
          pushClickMenuGTMEvent({
            text: t('$*components.header.button.login'),
          });
        }}
      >
        {t('$*components.header.button.login')}
      </Link>
      <Link
        href={ROUTE_URLS.AUTH_REGISTER}
        styles={tw`mx-3`}
        type="button"
        variant="contained"
        data-cy="nav__register"
        onClick={() => {
          pushClickMenuGTMEvent({
            text: t('$*components.header.nav.register'),
          });
        }}
      >
        {t('$*components.header.nav.register')}
      </Link>
    </div>
  );
};

export default AuthNav;
